module.exports = __webpack_public_path__ + "img/defaultavatar4.5e354c7d.png";